export default {"src":"/_next/static/media/OralCancer.998e857c.svg","height":75,"width":75,"blurWidth":0,"blurHeight":0};